import React from 'react';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';
import _keys from 'lodash/keys';
import _map from 'lodash/map';
import { Card } from 'baseui/card';
import { CardItem } from 'commons-ui';
import usePermission from 'commons-ui/src/permission/usePermission';
import { URL, LABEL, DYNAMIC_SWITCHER_RESOURCES, IMAGE_SOURCE } from './dynamicSwitcherHelper';
import { cardCSS, keyHeading, subKeyHeading } from './styles';
import { FINANCE_RESOURCES } from '../helper';

const useDynamicSwitcherHome = () => {
	const { hasPermission } = usePermission();
	const isEnabled = (subEntity: string): boolean => {
		return hasPermission({
			configPageName: FINANCE_RESOURCES.dynamicSwitcher,
			configResourceName: subEntity
		});
	};
	return { isEnabled };
};

const DynamicSwitcherHome: React.FC = () => {
	const history = useHistory();
	const { isEnabled } = useDynamicSwitcherHome();
	const [css] = useStyletron();

	return (
		<div className={css(keyHeading)}>
			{_map(_keys(DYNAMIC_SWITCHER_RESOURCES), (subEntity) => {
				return isEnabled(subEntity) ? (
					<div
						key={subEntity}
						className={css(subKeyHeading)}
						role='button'
						tabIndex={0}
						onClick={(e) => {
							e.preventDefault();
							history.push(URL[subEntity]);
						}}>
						<Card
							overrides={{
								Root: {
									style: () => cardCSS
								},
								Body: {
									component: () => <CardItem label={LABEL[subEntity]} img={IMAGE_SOURCE[subEntity]} />
								}
							}}
						/>
					</div>
				) : null;
			})}
		</div>
	);
};

export default DynamicSwitcherHome;
